/**
 * 音频处理
 */

import { ref } from 'vue'

export function useMedia() {
  const remoteAudio = ref<any>(null)
  // 创建音频
  function createAudio() {
    remoteAudio.value = new Audio()
    remoteAudio.value.id = 'remoteAudio'
    remoteAudio.value.autoplay = true
    remoteAudio.value.volume = 1
    console.log(remoteAudio, 'remoteAudio')
    document.body.appendChild(remoteAudio.value as any)
  }

  // 设置音频流
  function setAudioStreams(remoteStream) {
    if (remoteStream) {
      remoteAudio.value.srcObject = remoteStream
    }
  }

  // 移除音频
  function removeAudio() {
    if (document.getElementById('remoteAudio'))
      [document.body.removeChild(document.getElementById('remoteAudio'))]
  }

  return {
    createAudio,
    setAudioStreams,
    removeAudio
  }
}
